// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-container[data-v-bba02ffa]{position:relative;width:100%;max-width:100%;background-color:transparent}.phone-ui[data-v-bba02ffa]{max-width:300px;margin-left:auto;margin-right:auto}.message-ui[data-v-bba02ffa],.voice-ui[data-v-bba02ffa]{top:100px;left:50%;position:absolute;max-width:200px;transform:rotate(-5deg) translate(-50%)}.message-ui[data-v-bba02ffa]{color:#fff}", ""]);
// Exports
module.exports = exports;
